import React from 'react';

const UnitedStates = (props: { width: number }) => {
  return (
    <svg viewBox="0 0 7410 3900" {...props}>
      <title>United States Flag</title>
      <path d="M0 0h7410v3900H0z" fill="#b22234" />
      <path
        d="M0 450h7410m0 600H0m0 600h7410m0 600H0m0 600h7410m0 600H0"
        stroke="#fff"
        strokeWidth="300"
      />
      <path d="M0 0h2964v2100H0z" fill="#3c3b6e" />
      <g fill="#fff">
        <g id="us-d">
          <g id="us-c">
            <g id="us-e">
              <g id="us-b">
                <path
                  d="M247 90l70.534 217.082-184.66-134.164h228.253L176.466 307.082z"
                  id="us-a"
                />
                <use xlinkHref="#us-a" y="420" />
                <use xlinkHref="#us-a" y="840" />
                <use xlinkHref="#us-a" y="1260" />
              </g>
              <use xlinkHref="#us-a" y="1680" />
            </g>
            <use x="247" xlinkHref="#us-b" y="210" />
          </g>
          <use x="494" xlinkHref="#us-c" />
        </g>
        <use x="988" xlinkHref="#us-d" />
        <use x="1976" xlinkHref="#us-c" />
        <use x="2470" xlinkHref="#us-e" />
      </g>
    </svg>
  );
};

export default UnitedStates;
